/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import algoliasearch from 'algoliasearch/lite';
import daysjs from 'dayjs';
import {
	InstantSearch,
	SearchBox,
	RefinementList,
	Stats,
	Pagination,
	// eslint-disable-next-line no-unused-vars
	Highlight,
	Configure,
} from 'react-instantsearch-dom';
import EventCard from '@app/components/EventCard/EventCard';
import {
	connectRange,
	connectCurrentRefinements,
	connectHits,
} from 'react-instantsearch-core';
import '@app/components/ScheduleCalendar/ScheduleCalendar.sass';
import Button from '@app/components/Button/Button';
import Dialog from '@app/components/Dialog/Dialog';
import Calendar from 'react-calendar';
import '@app/components/ScheduleCalendar/ScheduleCalendar.sass';
import { pushEcommerceImpressions } from '@app/utils/UserEvent';
import { ClearRefinements } from 'react-instantsearch-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import NumericMenu from 'react-instantsearch-dom/dist/cjs/widgets/NumericMenu';
import { InternalRef } from '@app/utils/InternalRef';
import {
	withNotifications,
	NotificationsHOCProps,
} from '../NotificationProvider/NotificationProvider';
import PropTypes from 'prop-types';
import { ScrollTo } from 'react-instantsearch-dom';
import config from '@app/config/env';
import queryString from 'query-string';

const addQueryParameters = (url, params) => {
	const parsedUrl = new URL(url, window.location.origin);

	Object.entries(params).forEach(([key, value]) => {
		if (value) {
			parsedUrl.searchParams.set(key, value);
		}
	});

	return `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;
};

const searchClient = algoliasearch(config.algoliaAppID, config.algoliaAPIKey, {
	_useRequestCache: true,
});

let indexName = config.algoliaIndexName;

const ClearCalendarDates = items => {
	const { refine } = items;

	const clearDates = () => {
		refine(items.items[0].value);
		const x = document.getElementsByTagName('button');
		let i;
		for (i = 0; i < x.length; i++) {
			x[i].classList.remove('react-calendar__tile--active');
			x[i].classList.remove('react-calendar__tile--range');
			x[i].classList.remove('react-calendar__tile--rangeEnd');
			x[i].classList.remove('react-calendar__tile--rangeStart');
			x[i].addEventListener(
				'mouseover',
				e => {
					e.stopImmediatePropagation();
				},
				true,
			);
		}
	};
	return (
		<Button
			onClick={clearDates}
			label="Clear dates"
			size="tiny"
			disabled={!items.items.length}
		/>
	);
};

const EventSearchCalendar = options => {
	const { refine } = options;
	const searchValues = [];

	const onChange = value => {
		if (value && value.length > 1) {
			value.forEach(v => {
				searchValues.push(Math.floor(v / 1000));
			});
		} else {
			searchValues.push(Math.floor(value / 1000));
		}
		refine({
			min: searchValues[0],
			max: searchValues[1],
		});
	};

	return (
		<div>
			<Calendar onChange={onChange} selectRange={true} />
		</div>
	);
};

const ClearCalendarRefinements = connectCurrentRefinements(ClearCalendarDates);
const CustomRangeInput = connectRange(EventSearchCalendar);

export class EventSearch extends Component {
	constructor(props) {
		super(props);

		this.state = {
			// eslint-disable-next-line no-undef
			searchState: this.props.searchStateObject,
			isCalendarOpen: false,
			isMobileFiltersOpen: false,
			isDateFilterExpanded: false,
			isTypeFilterExpanded: false,
			isCityFilterExpanded: false,
			isCategoryFilterExpanded: false,
			isTagsFilterExpanded: false,
			isCountryFilterExpanded: false,
			isRegionFilterExpanded: false,
			showFilters: false,
			noEvents: false,
			organiserPage: false,
		};
	}

	async componentDidMount() {
		if (this.props.organiserId) {
			const organiserId = this.props.organiserId;
			await this.showFiltersForOrganiserPage(organiserId);
			this.setState({ organiserPage: true });
		} else {
			this.setState({ showFilters: true });
		}
	}

	showFiltersForOrganiserPage = async organiserId => {
		if (organiserId == 55878) {
			indexName = 'products_replica_1';
		}

		const index = searchClient.initIndex(indexName);

		const organiserFilter = `OrganiserId:${organiserId}`;
		// Comment above and use below for dev.
		// const organiserFilter = `OrganiserId:${55878}`;
		// Can replace 828 with any other live organiserId that has events.

		try {
			const response = await index.search({
				query: '',
				filters: organiserFilter,
			});

			const hits = response.hits;
			if (hits.length > 10) {
				this.setState({ showFilters: true });
			}

			if (hits.length === 0) {
				this.setState({ noEvents: true });
			}
		} catch (error) {
			// eslint-disable-next-line no-console
			console.error('Error occurred while fetching filters:', error);
		}
	};

	getLinkCampaignUrl = () => {
		if (!this.props.organiserId) {
			return null;
		}

		const linkCampaignUrl = queryString.parse(window.location.search).lc;

		return Array.isArray(linkCampaignUrl)
			? linkCampaignUrl[0]
			: linkCampaignUrl;
	};

	getProductUrl = productUrl => {
		const lc = this.getLinkCampaignUrl();
		return addQueryParameters(productUrl, {
			ref: InternalRef.eventsList,
			...(lc && { lc }),
		});
	};

	Hits = hits => {
		const fundraiser = 'Fundraiser';
		if (hits.hits && hits.hits.length > 0) {
			pushEcommerceImpressions(hits.hits, 'Events List');
		}
		return (
			<div>
				<ul className="ais-Hits-list">
					{hits.hits.map(hit => (
						<li key={hit.objectID}>
							<EventCard
								type={hit.Type}
								productUrl={this.getProductUrl(hit.ProductUrl)}
								imageUrl={hit.ImageUrl_Medium}
								productName={hit.ProductName}
								venueName={
									hit.Type === fundraiser
										? 'FUNDRAISER'
										: hit.VenueName
								}
								isOngoing={hit.Dates && hit.Dates.length > 1}
								dateFrom={
									hit.dates && hit.dates[0]
										? daysjs.unix(hit.dates[0]).toString()
										: daysjs.unix(hit.DateFrom).toString()
								}
							></EventCard>
						</li>
					))}
					<i className="hit-card hit-card-placeholder"></i>
					<i className="hit-card hit-card-placeholder"></i>
					<i className="hit-card hit-card-placeholder"></i>
				</ul>
			</div>
		);
	};

	CustomHits = connectHits(this.Hits);

	onSearchStateChange = searchState => {
		this.setState({ searchState });
	};

	toggleMobileFilters = modalOpen => {
		this.setState({
			isMobileFiltersOpen: modalOpen,
		});
	};

	toggleCalendar = modalOpen => {
		this.setState({
			isCalendarOpen: modalOpen,
		});
	};

	toggleMobileDateFilter = modalOpen => {
		this.setState({
			isDateFilterExpanded: modalOpen,
		});
	};

	toggleMobileTypeFilter = modalOpen => {
		this.setState({
			isTypeFilterExpanded: modalOpen,
		});
	};

	toggleMobileCityFilter = modalOpen => {
		this.setState({
			isCityFilterExpanded: modalOpen,
		});
	};

	toggleMobileCategoryFilter = modalOpen => {
		this.setState({
			isCategoryFilterExpanded: modalOpen,
		});
	};

	toggleMobileTagsFilter = modalOpen => {
		this.setState({
			isTagsFilterExpanded: modalOpen,
		});
	};

	toggleMobileCountryFilter = modalOpen => {
		this.setState({
			isCountryFilterExpanded: modalOpen,
		});
	};

	toggleMobileRegionFilter = modalOpen => {
		this.setState({
			isRegionFilterExpanded: modalOpen,
		});
	};

	render() {
		return (
			<InstantSearch
				searchClient={searchClient}
				indexName={indexName}
				searchState={this.state.searchState}
				onSearchStateChange={this.onSearchStateChange}
			>
				<ScrollTo scrollOn="page">
					{this.props.organiserId && (
						<Configure
							// replace 828 with any live event organiser of your choice.
							// filters={`OrganiserId:${55878}`}
							// Comment below and uncomment above if dev
							filters={`OrganiserId:${this.props.organiserId}`}
							hitsPerPage={18}
						/>
					)}
					{/* SEARCH */}
					<div
						className={
							!this.state.noEvents
								? 'search-panel'
								: 'search-panel no-events'
						}
					>
						{this.state.showFilters && (
							<div className="search-panel-filters">
								<SearchBox
									className="searchbox"
									translations={{
										placeholder: 'Search for events',
									}}
								/>

								{/* DESKTOP FILTERS */}
								<div className="filter filter-dates">
									<h3>Upcoming events</h3>
									{this.state.searchState.range &&
										this.state.searchState.range.Dates &&
										this.state.searchState.range.Dates
											.min &&
										this.state.searchState.range.Dates
											.max &&
										this.state.isCalendarOpen === false && (
											<div className="showing-range">
												<div className="showing-range-dates">
													<p>From: </p>
													<span className="showing-range-dates-span">
														{daysjs
															.unix(
																this.state
																	.searchState
																	.range.Dates
																	.min,
															)
															.format(
																'ddd D MMM YYYY',
															)}
													</span>
												</div>
												<div className="showing-range-dates">
													<p>Until: </p>
													<span className="showing-range-dates-span">
														{' '}
														{daysjs
															.unix(
																this.state
																	.searchState
																	.range.Dates
																	.max,
															)
															.format(
																'ddd D MMM YYYY',
															)}
													</span>
												</div>
												<ClearCalendarRefinements attribute="Dates" />
											</div>
										)}
									<div
										className={
											this.state.isCalendarOpen === true
												? 'calendar-dialog-open'
												: 'calendar-dialog-closed'
										}
									>
										<Dialog
											visible={this.state.isCalendarOpen}
											onHide={() => {
												this.toggleCalendar(false);
											}}
											header="Select date range"
										>
											<CustomRangeInput attribute="Dates" />
											<ClearCalendarRefinements attribute="Dates" />
										</Dialog>
									</div>
									{this.state.isCalendarOpen === false &&
										(!this.state.searchState.range ||
											(this.state.searchState.range
												.Dates &&
												this.state.searchState.range
													.Dates.min === undefined &&
												this.state.searchState.range
													.Dates.max ===
													undefined)) && (
											<div className="filter filter-dates-options">
												<NumericMenu
													attribute="Dates"
													items={[
														{
															label: 'Today',
															start: getTodayEvents(
																0,
																0,
																0,
																0,
															),
															end: getTodayEvents(
																24,
																0,
																0,
																0,
															),
														},
														{
															label:
																'This weekend',
															start: getThisWeekendEvents(
																5,
																0,
																0,
															),
															end: getThisWeekendEvents(
																8,
																0,
																0,
															),
														},
														{
															label:
																'Next 7 days',
															start: getTodayEvents(
																0,
																0,
																0,
																0,
															),
															end: getNextSevenDays(),
														},
														{
															label:
																'Next 30 days',
															start: getTodayEvents(
																0,
																0,
																0,
																0,
															),
															end: getNextThirtyDays(),
														},
													]}
													translations={{
														all: 'All dates',
													}}
												/>
												<Button
													onClick={() => {
														this.toggleCalendar(
															true,
														);
													}}
													label="Select custom dates"
													simple={true}
												/>
											</div>
										)}
								</div>
								<div className="filter-refinement">
									{!this.state.organiserPage && (
										<div className="filter">
											<h3>Type</h3>
											<RefinementList
												attribute="Type"
												transformItems={items => {
													return sortRefinementList(
														items,
													);
												}}
											/>
										</div>
									)}
									{!this.state.organiserPage && (
										<div className="filter">
											<h3>City</h3>
											<RefinementList
												attribute="City"
												transformItems={items => {
													return sortRefinementList(
														items,
													);
												}}
											/>
										</div>
									)}
									<div className="filter">
										<h3>Category</h3>
										<RefinementList
											attribute="Categories"
											transformItems={items => {
												return sortRefinementList(
													items,
												);
											}}
										/>
									</div>
									{!this.state.organiserPage && (
										<div className="filter">
											<h3>Country</h3>
											<RefinementList
												attribute="Country"
												transformItems={items => {
													return sortRefinementList(
														items,
													);
												}}
											/>
										</div>
									)}
									{!this.state.organiserPage && (
										<div className="filter">
											<h3>Region</h3>
											<RefinementList
												attribute="Region"
												transformItems={items => {
													return sortRefinementList(
														items,
													);
												}}
											/>
										</div>
									)}
									{this.state.organiserPage && (
										<div className="filter">
											<h3>Venue</h3>
											<RefinementList
												attribute="VenueName"
												transformItems={items => {
													return sortRefinementList(
														items,
													);
												}}
												showMore={true}
											/>
										</div>
									)}
									{this.state.organiserPage &&
										this.props.showEventTags && (
											<div className="filter">
												<h3>Tags</h3>
												<RefinementList
													attribute="Tags"
													transformItems={items => {
														return sortRefinementList(
															items,
														);
													}}
													showMore={true}
												/>
											</div>
										)}
								</div>
							</div>
						)}

						{/* RESULTS */}
						<div className="search-panel-frame">
							<div className="search-panel-stats">
								<h2>
									{this.props.organiserId ? (
										<Stats
											translations={{
												stats(nbHits) {
													return nbHits > 0
														? `${nbHits} upcoming events`
														: 'No upcoming events';
												},
											}}
										/>
									) : (
										<Stats
											translations={{
												stats(nbHits) {
													return nbHits > 0
														? `${nbHits} results found`
														: 'No results found';
												},
											}}
										/>
									)}
								</h2>
							</div>
							<div className="search-panel-results">
								<this.CustomHits />
							</div>
							{this.state.showFilters && (
								<div className="pagination">
									<Pagination
										translations={{
											page(currentRefinement) {
												return currentRefinement;
											},
										}}
									/>
								</div>
							)}
						</div>

						{/* MOBILE FILTER MENU */}
						<div className="filter-mobile">
							{this.state.showFilters && (
								<div
									className={
										this.state.isMobileFiltersOpen === true
											? 'filter-mobile-open'
											: 'filter-mobile-closed'
									}
								>
									<div className="filter-mobile-open-title">
										<h3>FILTER EVENTS</h3>
										<div
											role="button"
											className="filter-mobile-open-exit"
											tabIndex="0"
											onClick={() => {
												this.toggleMobileFilters(false);
											}}
											onKeyDown={() => {
												this.toggleMobileFilters(false);
											}}
										>
											<i className="fas fa-times"></i>
										</div>
									</div>
									{/* MOBILE DATE FILTER */}
									<div
										className={
											this.state.isDateFilterExpanded ===
											true
												? 'filter-mobile-open-item-expanded'
												: 'filter-mobile-open-item'
										}
									>
										<div className="filter-toggle">
											{this.state.isDateFilterExpanded ===
												true && (
												<div
													role="button"
													className="toggle-open"
													tabIndex="0"
													onClick={() => {
														this.toggleMobileDateFilter(
															false,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileDateFilter(
															false,
														);
													}}
												>
													<h3>DATE</h3>
													<i className="fas fa-chevron-right toggle-icon"></i>
												</div>
											)}
											{this.state.isDateFilterExpanded ===
												false && (
												<div
													role="button"
													tabIndex="0"
													className="toggle-closed"
													onClick={() => {
														this.toggleMobileDateFilter(
															true,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileDateFilter(
															true,
														);
													}}
												>
													<h3>DATE</h3>
													<i className="fas fa-chevron-left toggle-icon"></i>
												</div>
											)}
											<div
												className={
													this.state
														.isDateFilterExpanded ===
													true
														? 'filter-toggle-open-item'
														: 'filter-toggle-closed-item'
												}
											>
												<NumericMenu
													attribute="Dates"
													items={[
														{
															label: 'Today',
															start: getTodayEvents(
																0,
																0,
																0,
																0,
															),
															end: getTodayEvents(
																24,
																0,
																0,
																0,
															),
														},
														{
															label:
																'This weekend',
															start: getThisWeekendEvents(
																5,
																0,
																0,
															),
															end: getThisWeekendEvents(
																8,
																0,
																0,
															),
														},
														{
															label:
																'Next 7 days',
															start: getTodayEvents(
																0,
																0,
																0,
																0,
															),
															end: getNextSevenDays(),
														},
														{
															label:
																'Next 30 days',
															start: getTodayEvents(
																0,
																0,
																0,
																0,
															),
															end: getNextThirtyDays(),
														},
													]}
													translations={{
														all: 'All dates',
													}}
												/>
											</div>
										</div>
									</div>
									{/* MOBILE TYPE FILTER */}
									<div
										className={
											this.state.isTypeFilterExpanded ===
											true
												? 'filter-mobile-open-item-expanded'
												: 'filter-mobile-open-item'
										}
									>
										<div className="filter-toggle">
											{this.state.isTypeFilterExpanded ===
												true && (
												<div
													role="button"
													className="toggle-open"
													tabIndex="0"
													onClick={() => {
														this.toggleMobileTypeFilter(
															false,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileTypeFilter(
															false,
														);
													}}
												>
													<h3>TYPE</h3>
													<i className="fas fa-chevron-right toggle-icon"></i>
												</div>
											)}
											{this.state.isTypeFilterExpanded ===
												false && (
												<div
													role="button"
													tabIndex="0"
													className="toggle-closed"
													onClick={() => {
														this.toggleMobileTypeFilter(
															true,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileTypeFilter(
															true,
														);
													}}
												>
													<h3>TYPE</h3>
													<i className="fas fa-chevron-left toggle-icon"></i>
												</div>
											)}
											<div
												className={
													this.state
														.isTypeFilterExpanded ===
													true
														? 'filter-toggle-open-item'
														: 'filter-toggle-closed-item'
												}
											>
												<RefinementList
													attribute="Type"
													transformItems={items => {
														return sortRefinementList(
															items,
														);
													}}
												/>
											</div>
										</div>
									</div>
									{/* MOBILE CATEGORY FILTER */}
									<div
										className={
											this.state
												.isCategoryFilterExpanded ===
											true
												? 'filter-mobile-open-item-expanded'
												: 'filter-mobile-open-item'
										}
									>
										<div className="filter-toggle">
											{this.state
												.isCategoryFilterExpanded ===
												true && (
												<div
													role="button"
													className="toggle-open"
													tabIndex="0"
													onClick={() => {
														this.toggleMobileCategoryFilter(
															false,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileCategoryFilter(
															false,
														);
													}}
												>
													<h3>CATEGORY</h3>
													<i className="fas fa-chevron-right toggle-icon"></i>
												</div>
											)}
											{this.state
												.isCategoryFilterExpanded ===
												false && (
												<div
													role="button"
													tabIndex="0"
													className="toggle-closed"
													onClick={() => {
														this.toggleMobileCategoryFilter(
															true,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileCategoryFilter(
															true,
														);
													}}
												>
													<h3>CATEGORY</h3>
													<i className="fas fa-chevron-left toggle-icon"></i>
												</div>
											)}
											<div
												className={
													this.state
														.isCategoryFilterExpanded ===
													true
														? 'filter-toggle-open-item'
														: 'filter-toggle-closed-item'
												}
											>
												<RefinementList
													attribute="Categories"
													transformItems={items => {
														return sortRefinementList(
															items,
														);
													}}
												/>
											</div>
										</div>
									</div>
									{this.state.organiserPage &&
										this.props.showEventTags && (
											<div
												className={
													this.state
														.isTagsFilterExpanded ===
													true
														? 'filter-mobile-open-item-expanded'
														: 'filter-mobile-open-item'
												}
											>
												<div className="filter-toggle">
													{this.state
														.isTagsFilterExpanded ===
														true && (
														<div
															role="button"
															className="toggle-open"
															tabIndex="0"
															onClick={() => {
																this.toggleMobileTagsFilter(
																	false,
																);
															}}
															onKeyDown={() => {
																this.toggleMobileTagsFilter(
																	false,
																);
															}}
														>
															<h3>TAGS</h3>
															<i className="fas fa-chevron-right toggle-icon"></i>
														</div>
													)}
													{this.state
														.isTagsFilterExpanded ===
														false && (
														<div
															role="button"
															tabIndex="0"
															className="toggle-closed"
															onClick={() => {
																this.toggleMobileTagsFilter(
																	true,
																);
															}}
															onKeyDown={() => {
																this.toggleMobileTagsFilter(
																	true,
																);
															}}
														>
															<h3>TAGS</h3>
															<i className="fas fa-chevron-left toggle-icon"></i>
														</div>
													)}
													<div
														className={
															this.state
																.isTagsFilterExpanded ===
															true
																? 'filter-toggle-open-item'
																: 'filter-toggle-closed-item'
														}
													>
														<RefinementList
															attribute="Tags"
															transformItems={items => {
																return sortRefinementList(
																	items,
																);
															}}
														/>
													</div>
												</div>
											</div>
										)}
									{/* MOBILE CITY FILTER */}
									<div
										className={
											this.state.isCityFilterExpanded ===
											true
												? 'filter-mobile-open-item-expanded'
												: 'filter-mobile-open-item'
										}
									>
										<div className="filter-toggle">
											{this.state.isCityFilterExpanded ===
												true && (
												<div
													role="button"
													className="toggle-open"
													tabIndex="0"
													onClick={() => {
														this.toggleMobileCityFilter(
															false,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileCityFilter(
															false,
														);
													}}
												>
													<h3>CITY</h3>
													<i className="fas fa-chevron-right toggle-icon"></i>
												</div>
											)}
											{this.state.isCityFilterExpanded ===
												false && (
												<div
													role="button"
													tabIndex="0"
													className="toggle-closed"
													onClick={() => {
														this.toggleMobileCityFilter(
															true,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileCityFilter(
															true,
														);
													}}
												>
													<h3>CITY</h3>
													<i className="fas fa-chevron-left toggle-icon"></i>
												</div>
											)}
											<div
												className={
													this.state
														.isCityFilterExpanded ===
													true
														? 'filter-toggle-open-item'
														: 'filter-toggle-closed-item'
												}
											>
												<RefinementList
													attribute="City"
													transformItems={items => {
														return sortRefinementList(
															items,
														);
													}}
												/>
											</div>
										</div>
									</div>
									{/* MOBILE REGION FILTER */}
									<div
										className={
											this.state
												.isRegionFilterExpanded === true
												? 'filter-mobile-open-item-expanded'
												: 'filter-mobile-open-item'
										}
									>
										<div className="filter-toggle">
											{this.state
												.isRegionFilterExpanded ===
												true && (
												<div
													role="button"
													className="toggle-open"
													tabIndex="0"
													onClick={() => {
														this.toggleMobileRegionFilter(
															false,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileRegionFilter(
															false,
														);
													}}
												>
													<h3>REGION</h3>
													<i className="fas fa-chevron-right toggle-icon"></i>
												</div>
											)}
											{this.state
												.isRegionFilterExpanded ===
												false && (
												<div
													role="button"
													tabIndex="0"
													className="toggle-closed"
													onClick={() => {
														this.toggleMobileRegionFilter(
															true,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileRegionFilter(
															true,
														);
													}}
												>
													<h3>REGION</h3>
													<i className="fas fa-chevron-left toggle-icon"></i>
												</div>
											)}
											<div
												className={
													this.state
														.isRegionFilterExpanded ===
													true
														? 'filter-toggle-open-item'
														: 'filter-toggle-closed-item'
												}
											>
												<RefinementList
													attribute="Region"
													transformItems={items => {
														return sortRefinementList(
															items,
														);
													}}
												/>
											</div>
										</div>
									</div>
									{/* MOBILE COUNTRY FILTER */}
									<div
										className={
											this.state
												.isCountryFilterExpanded ===
											true
												? 'filter-mobile-open-item-expanded'
												: 'filter-mobile-open-item'
										}
									>
										<div className="filter-toggle">
											{this.state
												.isCountryFilterExpanded ===
												true && (
												<div
													role="button"
													className="toggle-open"
													tabIndex="0"
													onClick={() => {
														this.toggleMobileCountryFilter(
															false,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileCountryFilter(
															false,
														);
													}}
												>
													<h3>COUNTRY</h3>
													<i className="fas fa-chevron-right toggle-icon"></i>
												</div>
											)}
											{this.state
												.isCountryFilterExpanded ===
												false && (
												<div
													role="button"
													tabIndex="0"
													className="toggle-closed"
													onClick={() => {
														this.toggleMobileCountryFilter(
															true,
														);
													}}
													onKeyDown={() => {
														this.toggleMobileCountryFilter(
															true,
														);
													}}
												>
													<h3>COUNTRY</h3>
													<i className="fas fa-chevron-left toggle-icon"></i>
												</div>
											)}
											<div
												className={
													this.state
														.isCountryFilterExpanded ===
													true
														? 'filter-toggle-open-item'
														: 'filter-toggle-closed-item'
												}
											>
												<RefinementList
													attribute="Country"
													transformItems={items => {
														return sortRefinementList(
															items,
														);
													}}
												/>
											</div>
										</div>
									</div>
									<div className="filter-mobile-open-buttons">
										<ClearRefinements
											translations={{
												reset: 'CLEAR FILTERS',
											}}
										/>
										<Button
											onClick={() => {
												this.toggleMobileFilters(false);
											}}
											label="Apply filters"
											size="tiny"
										/>
									</div>
								</div>
							)}
						</div>
						{this.state.isMobileFiltersOpen === false &&
							this.state.showFilters && (
								<div className="filter-mobile">
									<div className="filter-mobile-openmodal">
										<Button
											onClick={() => {
												this.toggleMobileFilters(true);
											}}
											label="Filter events"
											size="tiny"
											icon={
												<FontAwesomeIcon
													icon={faFilter}
												/>
											}
										/>
									</div>
								</div>
							)}
					</div>
				</ScrollTo>
			</InstantSearch>
		);
	}
}

function getTodayEvents(hour, minute, second, milisecond) {
	const today = new Date();

	const result = today.setHours(hour, minute, second, milisecond);

	return result / 1000;
}

function getThisWeekendEvents(dayOfWeek, hour, minute) {
	const now = new Date();
	const eventDate = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
		hour,
		minute,
	);
	const todaysDay = now.getDay();

	switch (dayOfWeek) {
		case 5:
			if (todaysDay === 0 || todaysDay === 5 || todaysDay === 6) {
				eventDate.setDate(eventDate.getDate());
			}
			if (todaysDay === 1) {
				eventDate.setDate(eventDate.getDate() + 4);
			}
			if (todaysDay === 2) {
				eventDate.setDate(eventDate.getDate() + 3);
			}
			if (todaysDay === 3) {
				eventDate.setDate(eventDate.getDate() + 2);
			}
			if (todaysDay === 4) {
				eventDate.setDate(eventDate.getDate() + 1);
			}
			break;
		case 8:
			if (todaysDay === 0) {
				eventDate.setDate(eventDate.getDate() + 1);
			}
			if (todaysDay === 1) {
				eventDate.setDate(eventDate.getDate() + 7);
			}
			if (todaysDay === 2) {
				eventDate.setDate(eventDate.getDate() + 6);
			}
			if (todaysDay === 3) {
				eventDate.setDate(eventDate.getDate() + 5);
			}
			if (todaysDay === 4) {
				eventDate.setDate(eventDate.getDate() + 4);
			}
			if (todaysDay === 5) {
				eventDate.setDate(eventDate.getDate() + 3);
			}
			if (todaysDay === 6) {
				eventDate.setDate(eventDate.getDate() + 2);
			}
	}

	return eventDate / 1000;
}

function getNextThirtyDays() {
	const now = new Date();
	const thirtyDay = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate() + 30,
	);

	return thirtyDay / 1000;
}

function getNextSevenDays() {
	const now = new Date();
	const sevenDays = new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate() + 8,
	);

	return sevenDays / 1000;
}

function sortRefinementList(items) {
	return items.sort((a, b) => {
		if (b.count != a.count) {
			return b.count - a.count;
		} else {
			if (a.label < b.label) return -1;
			if (a.label > b.label) return 1;
			return 0;
		}
	});
}

EventSearch.propTypes = {
	...NotificationsHOCProps,
	searchStateObject: PropTypes.object,
	organiserId: PropTypes.string,
	showEventTags: PropTypes.bool,
};

export default withNotifications(EventSearch);
